export const toFixedByDefault = (money, optionalDigits = 2) => {
    return Number(money).toFixed(optionalDigits)
}
